import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ImageThumbnailComponent } from '@web/shared/ui';
import { Guid, isNotNil, Nillable } from '@web/utils';
import { PublicBannerDataSourceService } from '../../services/public-banner-data-source.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-public-home-banner-carousel-item',
  imports: [CommonModule, ImageThumbnailComponent, NgOptimizedImage],
  templateUrl: './public-home-banner-carousel-item.component.html',
  styleUrl: './public-home-banner-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicHomeBannerCarouselItemComponent {
  private readonly bannerDataSource = inject(PublicBannerDataSourceService);

  public readonly bannerId = input.required<Guid>();
  public readonly imageSrc = input.required<string>();
  public readonly mobileImageSrc = input<Nillable<string>>();
  public readonly imageAlt = input.required<string>();
  public readonly externalLink = input<Nillable<string>>();

  protected readonly isNotNil = isNotNil;

  public async handleLinkClick(event: MouseEvent): Promise<void> {
    event.preventDefault();

    const url = this.externalLink();

    if (!url) {
      return;
    }

    await firstValueFrom(
      this.bannerDataSource.registerRedirectById(this.bannerId()),
    );
    window.location.assign(url);
  }
}
